__turbopack_context__.v({
  "actionsWrp": "startActions-module-scss-module__lk7VOa__actionsWrp",
  "bookDemoButton": "startActions-module-scss-module__lk7VOa__bookDemoButton",
  "buttonsDivider": "startActions-module-scss-module__lk7VOa__buttonsDivider",
  "getStartedButton": "startActions-module-scss-module__lk7VOa__getStartedButton",
});
